"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.REQUEST = exports.SAGA = void 0;
var SAGA = 'apiFlow/emailSettings/changeProperty/SAGA';
exports.SAGA = SAGA;
var REQUEST = 'apiFlow/emailSettings/changeProperty/REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'apiFlow/emailSettings/changeProperty/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/emailSettings/changeProperty/FAILURE';
exports.FAILURE = FAILURE;